import L10n from "lib/carrot-l10n"
import { FeatureConfiguration } from "types/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type WhoReceivedCareChoice = {
  label: string
  id: string
  selected: boolean
  filter?: (config: FeatureConfiguration) => boolean
}

export const whoReceivedCareChoices: WhoReceivedCareChoice[] = [
  {
    label: l`Me`,
    id: "MEMBER",
    selected: false
  },
  {
    label: l`My legal spouse or dependent partner`,
    id: "LEGAL_PARTNER",
    selected: false
  },
  {
    label: l`My non-married partner`,
    id: "NON_MARRIED_PARTNER",
    selected: false,
    filter: (config) => config.isPartnerEnabled
  },
  {
    label: l`Birth parent for adoption`,
    id: "BIRTH_PARENT",
    selected: false,
    filter: (config) => config.isAdoptionEnabled
  },
  {
    label: l`Donor`,
    id: "DONOR",
    selected: false,
    filter: (config) => config.isDonorEnabled
  },
  {
    label: l`Gestational carrier`,
    id: "GESTATIONAL_CARRIER",
    selected: false,
    filter: (config) => config.isGcEnabled
  }
]
